<template>
  <div class="condicional-list-page">
    <FilterFields :fields="filterFields" />

    <div class="condicional-report-grid mb-4">
      <button
        type="button"
        class="condicional-report-card"
        @click="aplicarFiltroStatus(2)"
      >
        <span>Condicionais em aberto</span>
        <strong>{{ relatorio.condicionais_em_aberto || 0 }}</strong>
      </button>

      <button
        type="button"
        class="condicional-report-card"
        @click="aplicarFiltroVencidas"
      >
        <span>Condicionais vencidas</span>
        <strong>{{ relatorio.condicionais_vencidas || 0 }}</strong>
      </button>

      <button
        type="button"
        class="condicional-report-card"
        @click="$bvModal.show('condicionalProdutosRelatorio')"
      >
        <span>Peças em condicional</span>
        <strong>{{
          numberToReal(relatorio.quantidade_pecas_em_aberto || 0, 4)
        }}</strong>
      </button>

      <button
        type="button"
        class="condicional-report-card"
        @click="$bvModal.show('condicionalProdutosRelatorio')"
      >
        <span>Valor em aberto</span>
        <strong>
          R$ {{ numberToReal(relatorio.valor_total_em_aberto || 0, 2) }}
        </strong>
      </button>
    </div>

    <TableApp
      titulo="Condicional de Mercadorias"
      api-url="/condicional-mercadorias/lista"
      :fields="fields"
      classFilterColumn="numero"
      ref="condicionalList"
      :perPage="30"
      :fixedLayout="true"
    >
      <template slot="toolbar-actions">
        <button
          v-if="temPermissaoCondicional"
          type="button"
          class="btn btn-dark font-weight-bolder font-size-sm"
          @click="$router.push({ name: 'condicionalMercadoriasNova' })"
        >
          Nova Condicional
        </button>
      </template>

      <template slot="customRow" scope="props">
        <span v-if="props.field === 'numero'">
          <strong>{{ props.rowData.numero }}</strong>
        </span>

        <span v-if="props.field === 'cliente'">
          {{ nomeCliente(props.rowData) }}
        </span>

        <span v-if="props.field === 'cnpj_cpf'">
          {{
            props.rowData.cnpj_cpf ? formatCpfCnpj(props.rowData.cnpj_cpf) : "-"
          }}
        </span>

        <span v-if="props.field === 'vendedor'">
          {{ props.rowData.vendedor || "-" }}
        </span>

        <span v-if="props.field === 'data_saida'">
          {{ formatDate(props.rowData.data_saida) }}
        </span>

        <span v-if="props.field === 'data_limite_retorno'">
          {{ formatDate(props.rowData.data_limite_retorno) }}
        </span>

        <span v-if="props.field === 'dias_em_aberto'">
          {{ diasEmAberto(props.rowData) }}
        </span>

        <span v-if="props.field === 'quantidade_total_enviada'">
          {{ numberToReal(props.rowData.quantidade_total_enviada, 4) }}
        </span>

        <span v-if="props.field === 'valor_total_enviado'">
          R$ {{ numberToReal(props.rowData.valor_total_enviado, 2) }}
        </span>

        <span v-if="props.field === 'status'">
          <CondicionalStatusBadge :status="props.rowData.status" />
        </span>

        <span v-if="props.field === 'actions'">
          <div class="action-buttons">
            <button
              v-if="temPermissaoCondicional"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Visualizar'"
              @click="visualizar(props.rowData)"
            >
              <Eye :size="12" />
            </button>

            <button
              v-if="temPermissaoCondicional && podeEditarCondicional(props.rowData)"
              class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Editar'"
              @click="editar(props.rowData)"
            >
              <Pencil :size="12" />
            </button>

            <button
              v-if="
                temPermissaoCondicional &&
                podeImprimirCondicional(props.rowData)
              "
              class="btn btn-sm btn-icon mr-2 condicional-print-action"
              v-b-tooltip.hover.bottom="'Imprimir'"
              @click="abrirModalImpressao(props.rowData)"
            >
              <Printer :size="12" />
            </button>

            <button
              v-if="
                temPermissaoCondicional && Number(props.rowData.status) === 1
              "
              class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Confirmar saída'"
              @click="confirmarSaida(props.rowData)"
            >
              <Check :size="12" />
            </button>

            <button
              v-if="
                temPermissaoCondicional && podeProcessarRetorno(props.rowData)
              "
              class="btn btn-sm btn-warning btn-hover-warning btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Processar retorno'"
              @click="abrirRetorno(props.rowData)"
            >
              <Undo :size="12" />
            </button>

            <button
              v-if="
                temPermissaoCondicional &&
                (Number(props.rowData.status) === 1 ||
                  Number(props.rowData.status) === 2)
              "
              class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Cancelar'"
              @click="cancelar(props.rowData)"
            >
              <Close :size="12" />
            </button>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal
      id="condicionalDetalhes"
      title="Condicional de Mercadorias"
      size="xl"
      centered
      hide-footer
    >
      <div v-if="condicionalSelecionada">
        <b-row class="mb-4">
          <b-col md="2">
            <strong>Número</strong>
            <p>{{ condicionalSelecionada.numero }}</p>
          </b-col>
          <b-col md="4">
            <strong>Cliente</strong>
            <p>{{ nomeCliente(condicionalSelecionada) }}</p>
          </b-col>
          <b-col md="3">
            <strong>Vendedor</strong>
            <p>{{ nomeVendedor(condicionalSelecionada) }}</p>
          </b-col>
          <b-col md="3">
            <strong>Status</strong>
            <p>
              <CondicionalStatusBadge :status="condicionalSelecionada.status" />
            </p>
          </b-col>
          <b-col md="2">
            <strong>Saída</strong>
            <p>{{ formatDate(condicionalSelecionada.data_saida) }}</p>
          </b-col>
          <b-col md="2">
            <strong>Limite</strong>
            <p>{{ formatDate(condicionalSelecionada.data_limite_retorno) }}</p>
          </b-col>
          <b-col md="2">
            <strong>Enviado</strong>
            <p>
              {{
                numberToReal(condicionalSelecionada.quantidade_total_enviada, 4)
              }}
            </p>
          </b-col>
          <b-col md="2">
            <strong>Vendido</strong>
            <p>
              {{
                numberToReal(condicionalSelecionada.quantidade_total_vendida, 4)
              }}
            </p>
          </b-col>
          <b-col md="2">
            <strong>Devolvido</strong>
            <p>
              {{
                numberToReal(
                  condicionalSelecionada.quantidade_total_devolvida,
                  4
                )
              }}
            </p>
          </b-col>
          <b-col md="2">
            <strong>Pendente</strong>
            <p>{{ numberToReal(quantidadePendenteCondicional, 4) }}</p>
          </b-col>
        </b-row>

        <h5 class="font-weight-bold mb-3">Itens</h5>
        <div class="table-responsive mb-5">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Produto</th>
                <th class="text-right">Enviada</th>
                <th class="text-right">Vendida</th>
                <th class="text-right">Devolvida</th>
                <th class="text-right">Danificada</th>
                <th class="text-right">Perdida</th>
                <th class="text-right">Pendente</th>
                <th class="text-right">Valor unitário</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in condicionalSelecionada.itens || []"
                :key="item.id_condicional_mercadoria_item"
              >
                <td>{{ descricaoProduto(item) }}</td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_enviada, 4) }}
                </td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_vendida, 4) }}
                </td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_devolvida, 4) }}
                </td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_danificada, 4) }}
                </td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_perdida, 4) }}
                </td>
                <td class="text-right">
                  {{ numberToReal(quantidadePendente(item), 4) }}
                </td>
                <td class="text-right">
                  R$ {{ numberToReal(valorUnitarioItem(item), 2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h5 class="font-weight-bold mb-3">Histórico</h5>
        <div class="table-responsive">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Data</th>
                <th>Movimento</th>
                <th>Produto</th>
                <th class="text-right">Quantidade</th>
                <th class="text-right">Valor</th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="movimento in historicoCondicional"
                :key="movimento.id_condicional_mercadoria_movimento"
              >
                <td>{{ formatDateTime(movimento.created_at) }}</td>
                <td>{{ movimentoTipoLabel(movimento.tipo) }}</td>
                <td>{{ descricaoProduto(movimento.item || {}) }}</td>
                <td class="text-right">
                  {{ numberToReal(movimento.quantidade, 4) }}
                </td>
                <td class="text-right">
                  R$ {{ numberToReal(movimento.valor, 2) }}
                </td>
                <td>{{ movimento.observacao || "-" }}</td>
              </tr>
              <tr v-if="!historicoCondicional.length">
                <td colspan="6" class="text-center text-muted">
                  Nenhum movimento registrado.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="condicionalRetorno"
      title="Processar retorno"
      size="xl"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="retornoCondicional">
        <b-row class="mb-4">
          <b-col md="2">
            <strong>Número</strong>
            <p>{{ retornoCondicional.numero }}</p>
          </b-col>
          <b-col md="4">
            <strong>Cliente</strong>
            <p>{{ nomeCliente(retornoCondicional) }}</p>
          </b-col>
          <b-col md="3">
            <strong>Status</strong>
            <p>
              <CondicionalStatusBadge :status="retornoCondicional.status" />
            </p>
          </b-col>
          <b-col md="3">
            <strong>Saldo editável</strong>
            <p>{{ numberToReal(retornoTotais.pendenteOriginal, 4) }}</p>
          </b-col>
        </b-row>

        <div class="retorno-toolbar mb-3">
          <div class="retorno-toolbar-main">
            <div class="retorno-toolbar-actions">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary mr-2"
                @click="preencherRetorno('quantidade_vendida')"
              >
                Vender tudo
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-success mr-2"
                @click="preencherRetorno('quantidade_devolvida')"
              >
                Devolver tudo
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-warning"
                @click="marcarNaoLancadosComoVendidos"
              >
                Vender não selecionados
              </button>
            </div>

            <strong
              >Total vendido: R$
              {{ numberToReal(retornoTotais.valorVendido, 2) }}</strong
            >
          </div>

          <div class="retorno-leitor-card">
            <span class="retorno-leitor-label">Leitura rápida</span>
            <div class="retorno-leitor">
              <div class="btn-group btn-group-sm mr-2" role="group">
                <button
                  type="button"
                  class="btn"
                  :class="
                    retornoLeituraModo === 'quantidade_devolvida'
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="selecionarModoLeitura('quantidade_devolvida')"
                >
                  Devolver
                </button>
                <button
                  type="button"
                  class="btn"
                  :class="
                    retornoLeituraModo === 'quantidade_danificada'
                      ? 'btn-warning'
                      : 'btn-outline-warning'
                  "
                  @click="selecionarModoLeitura('quantidade_danificada')"
                >
                  Avariar
                </button>
              </div>

              <b-form-input
                ref="retornoCodigoInput"
                v-model="retornoCodigoLeitura"
                size="sm"
                class="retorno-codigo-input"
                placeholder="Código"
                @keyup.enter="lancarCodigoRetorno"
              />

              <button
                type="button"
                class="btn btn-sm btn-primary ml-2"
                @click="lancarCodigoRetorno"
              >
                Lançar
              </button>
            </div>
          </div>
        </div>

        <b-alert v-if="retornoErros.length" show variant="danger" class="mb-3">
          {{ retornoErros[0] }}
        </b-alert>

        <div class="table-responsive mb-4">
          <table class="table table-sm table-striped retorno-table">
            <thead>
              <tr>
                <th>Produto</th>
                <th class="text-right">Editável</th>
                <th>Vender</th>
                <th>Devolver</th>
                <th>Avariar</th>
                <th>Perder</th>
                <th class="text-center">Manter</th>
                <th class="text-right">Saldo</th>
                <th class="text-right">Total vendido</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in retornoItens"
                :key="item.id_condicional_mercadoria_item"
                :class="{ 'table-danger': Boolean(retornoItemErro(item)) }"
              >
                <td>
                  <strong>{{ item.produto }}</strong>
                  <small class="d-block text-muted">
                    Código: {{ item.codigo || "-" }}
                  </small>
                </td>
                <td class="text-right">
                  {{ numberToReal(item.quantidade_pendente_original, 4) }}
                </td>
                <td>
                  <b-form-input
                    v-model.number="item.quantidade_vendida"
                    type="number"
                    min="0"
                    step="0.0001"
                    @input="normalizarRetornoItem(item, 'quantidade_vendida')"
                  />
                </td>
                <td>
                  <b-form-input
                    v-model.number="item.quantidade_devolvida"
                    type="number"
                    min="0"
                    step="0.0001"
                    @input="normalizarRetornoItem(item, 'quantidade_devolvida')"
                  />
                </td>
                <td>
                  <b-form-input
                    v-model.number="item.quantidade_danificada"
                    type="number"
                    min="0"
                    step="0.0001"
                    @input="
                      normalizarRetornoItem(item, 'quantidade_danificada')
                    "
                  />
                </td>
                <td>
                  <b-form-input
                    v-model.number="item.quantidade_perdida"
                    type="number"
                    min="0"
                    step="0.0001"
                    @input="normalizarRetornoItem(item, 'quantidade_perdida')"
                  />
                </td>
                <td class="text-center">
                  <b-form-checkbox
                    v-model="item.manter_pendente"
                    :disabled="retornoItemPendente(item) <= 0"
                  />
                </td>
                <td class="text-right">
                  {{ numberToReal(retornoItemPendente(item), 4) }}
                </td>
                <td class="text-right">
                  R$ {{ numberToReal(totalVendidoRetornoItem(item), 2) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>Total</th>
                <th class="text-right">
                  {{ numberToReal(retornoTotais.pendenteOriginal, 4) }}
                </th>
                <th>{{ numberToReal(retornoTotais.vendida, 4) }}</th>
                <th>{{ numberToReal(retornoTotais.devolvida, 4) }}</th>
                <th>{{ numberToReal(retornoTotais.danificada, 4) }}</th>
                <th>{{ numberToReal(retornoTotais.perdida, 4) }}</th>
                <th />
                <th class="text-right">
                  {{ numberToReal(retornoTotais.pendente, 4) }}
                </th>
                <th class="text-right">
                  R$ {{ numberToReal(retornoTotais.valorVendido, 2) }}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-light-primary font-weight-bold mr-2"
            @click="$bvModal.hide('condicionalRetorno')"
          >
            Voltar
          </button>
          <button
            type="button"
            class="btn btn-primary font-weight-bold"
            :disabled="!retornoPodeProcessar"
            @click="processarRetorno"
          >
            Processar retorno
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="condicionalImpressao"
      title="Imprimir condicional"
      centered
      hide-footer
    >
      <div v-if="condicionalImpressao">
        <p class="text-muted mb-4">
          Escolha o formato para a condicional
          <strong>{{ condicionalImpressao.numero }}</strong
          >.
        </p>

        <div class="condicional-print-options">
          <button
            class="condicional-print-option"
            :disabled="imprimindoCondicional"
            @click="imprimirCondicional('a4')"
          >
            <span class="condicional-print-title">A4 completo</span>
            <span class="condicional-print-description">
              Documento detalhado com resumo, itens, termos e assinaturas.
            </span>
          </button>

          <button
            class="condicional-print-option"
            :disabled="imprimindoCondicional"
            @click="imprimirCondicional('80')"
          >
            <span class="condicional-print-title">80 colunas</span>
            <span class="condicional-print-description">
              Via simplificada para impressora térmica ou conferência rápida.
            </span>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="condicionalProdutosRelatorio"
      title="Produtos em condicional"
      size="lg"
      centered
      hide-footer
    >
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Produto</th>
              <th>Nº condicionais</th>
              <th class="text-right">Peças</th>
              <th class="text-right">Valor em aberto</th>
              <th class="text-right">Condicionais</th>
              <th class="text-right">Clientes</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="produto in produtosEmCondicional"
              :key="produto.id_produto"
            >
              <td>
                <strong>{{ produto.produto || "-" }}</strong>
                <small class="d-block text-muted">
                  Código: {{ produto.codigo || "-" }}
                </small>
              </td>
              <td>{{ produto.numeros_condicionais || "-" }}</td>
              <td class="text-right">
                {{ numberToReal(produto.quantidade_em_aberto, 4) }}
              </td>
              <td class="text-right">
                R$ {{ numberToReal(produto.valor_em_aberto, 2) }}
              </td>
              <td class="text-right">{{ produto.condicionais }}</td>
              <td class="text-right">{{ produto.clientes }}</td>
            </tr>
            <tr v-if="!produtosEmCondicional.length">
              <td colspan="6" class="text-center text-muted">
                Nenhum produto em condicional.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import swal from "sweetalert";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";
import Eye from "vue-material-design-icons/Eye.vue";
import Check from "vue-material-design-icons/Check.vue";
import Close from "vue-material-design-icons/Close.vue";
import Printer from "vue-material-design-icons/Printer.vue";
import Undo from "vue-material-design-icons/Undo.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import { filtersStore } from "@/components/FilterFields/filtersStore";
import { userAccessStore } from "@/userAccessStore";
import { SistemaMixin } from "@/modules/Application";
import CondicionalMercadoriaData from "../CondicionalMercadoriaData";
import CondicionalStatusBadge from "../components/CondicionalStatusBadge";

export default {
  name: "condicionalMercadorias",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    FilterFields,
    CondicionalStatusBadge,
    Eye,
    Check,
    Close,
    Printer,
    Undo,
    Pencil,
  },
  data() {
    return {
      condicionalSelecionada: null,
      historicoCondicional: [],
      filtersStore,
      userAccessStore,
      relatorio: {
        condicionais_em_aberto: 0,
        condicionais_vencidas: 0,
        quantidade_pecas_em_aberto: 0,
        valor_total_em_aberto: 0,
        produtos_em_condicional: [],
      },
      relatorioTimeout: null,
      retornoCondicional: null,
      retornoItens: [],
      retornoLeituraModo: "quantidade_devolvida",
      retornoCodigoLeitura: "",
      condicionalImpressao: null,
      imprimindoCondicional: false,
      filterFields: [
        { type: "text", label: "Número", field: "numero" },
        { type: "text", label: "Cliente", field: "cliente" },
        { type: "text", label: "CPF/CNPJ", field: "cnpj_cpf" },
        { type: "text", label: "Vendedor", field: "vendedor" },
        { type: "date", label: "Saída", field: "data_saida" },
        {
          type: "date",
          label: "Limite de retorno",
          field: "data_limite_retorno",
        },
        {
          type: "select",
          label: "Status",
          field: "status",
          options: [
            { text: "Todos", value: null },
            { text: "Rascunho", value: 1 },
            { text: "Em aberto", value: 2 },
            { text: "Parcial", value: 3 },
            { text: "Vencida", value: 4 },
            { text: "Fechada com venda", value: 5 },
            { text: "Fechada sem venda", value: 6 },
            { text: "Cancelada", value: 7 },
            { text: "Com perda/dano", value: 8 },
          ],
        },
        {
          type: "select",
          label: "Vencidas",
          field: "vencidas",
          options: [
            { text: "Todos", value: null },
            { text: "Sim", value: true },
            { text: "Não", value: false },
          ],
        },
      ],
      fields: [
        {
          label: "Número",
          field: "numero",
          slot: true,
          sortable: true,
          width: "5%",
        },
        {
          label: "Cliente",
          field: "cliente",
          slot: true,
          sortable: true,
          width: "18%",
        },
        {
          label: "CPF/CNPJ",
          field: "cnpj_cpf",
          slot: true,
          sortable: true,
          width: "12%",
        },
        {
          label: "Vendedor",
          field: "vendedor",
          slot: true,
          sortable: true,
          width: "12%",
        },
        {
          label: "Saída",
          field: "data_saida",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Limite",
          field: "data_limite_retorno",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Dias",
          field: "dias_em_aberto",
          slot: true,
          sortable: false,
          width: "7%",
        },
        {
          label: "Peças",
          field: "quantidade_total_enviada",
          slot: true,
          sortable: true,
          width: "8%",
        },
        {
          label: "Valor",
          field: "valor_total_enviado",
          slot: true,
          sortable: true,
          width: "10%",
        },
        {
          label: "Status",
          field: "status",
          slot: true,
          sortable: true,
          width: "11%",
        },
        {
          label: "Ações",
          field: "actions",
          slot: true,
          sortable: false,
          width: "15%",
        },
      ],
    };
  },
  computed: {
    produtosEmCondicional() {
      return this.relatorio.produtos_em_condicional || [];
    },
    temPermissaoCondicional() {
      return Boolean(this.userAccessStore.access?.["condicional-mercadorias"]);
    },
    quantidadePendenteCondicional() {
      return (this.condicionalSelecionada?.itens || []).reduce(
        (total, item) => total + this.quantidadePendente(item),
        0
      );
    },
    retornoTotais() {
      return this.retornoItens.reduce(
        (totais, item) => {
          totais.pendenteOriginal += Number(
            item.quantidade_pendente_original || 0
          );
          totais.vendida += Number(item.quantidade_vendida || 0);
          totais.devolvida += Number(item.quantidade_devolvida || 0);
          totais.danificada += Number(item.quantidade_danificada || 0);
          totais.perdida += Number(item.quantidade_perdida || 0);
          totais.pendente += this.retornoItemPendente(item);
          totais.valorVendido += this.totalVendidoRetornoItem(item);

          return totais;
        },
        {
          pendenteOriginal: 0,
          vendida: 0,
          devolvida: 0,
          danificada: 0,
          perdida: 0,
          pendente: 0,
          valorVendido: 0,
        }
      );
    },
    retornoErros() {
      const erros = this.retornoItens
        .map((item) => this.retornoItemErro(item))
        .filter(Boolean);

      if (!this.retornoMovimentos.length) {
        erros.unshift(
          "Informe ao menos uma quantidade vendida, devolvida, avariada ou perdida."
        );
      }

      return erros;
    },
    retornoMovimentos() {
      return this.retornoItens.filter((item) =>
        this.retornoItemTeveAlteracao(item)
      );
    },
    retornoPodeProcessar() {
      return (
        this.retornoMovimentos.length > 0 && this.retornoErros.length === 0
      );
    },
  },
  mounted() {
    this.carregarRelatorio();
  },
  watch: {
    filtersStore: {
      handler() {
        if (this.relatorioTimeout) {
          clearTimeout(this.relatorioTimeout);
        }

        this.relatorioTimeout = setTimeout(() => {
          this.carregarRelatorio();
        }, 250);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm") : "-";
    },
    diasEmAberto(row) {
      const dataSaida = row.data_saida || row.created_at;
      const dataFechamento = row.data_fechamento || new Date();

      if (!dataSaida) {
        return "-";
      }

      return moment(dataFechamento).diff(moment(dataSaida), "days");
    },
    nomeCliente(condicional) {
      if (condicional?.responsabilidade_vendedor) {
        return "Responsabilidade do vendedor";
      }

      return condicional?.cliente?.nome || condicional?.cliente || "-";
    },
    nomeVendedor(condicional) {
      return condicional?.vendedor?.nome || condicional?.vendedor || "-";
    },
    descricaoProduto(item) {
      return (
        item.descricao_produto_snapshot ||
        item.produto?.descricao ||
        item.produto ||
        "-"
      );
    },
    valorUnitarioItem(item) {
      const valorUnitario = Number(item.valor_unitario || 0);

      if (valorUnitario > 0) {
        return valorUnitario;
      }

      const quantidade = Number(item.quantidade_enviada || 0);

      if (quantidade <= 0) {
        return 0;
      }

      return Number(item.valor_total || 0) / quantidade;
    },
    quantidadePendente(item) {
      return Math.max(
        0,
        Number(item.quantidade_enviada || 0) -
          Number(item.quantidade_vendida || 0) -
          Number(item.quantidade_devolvida || 0) -
          Number(item.quantidade_danificada || 0) -
          Number(item.quantidade_perdida || 0)
      );
    },
    saldoPerdaDanoEditavel(item) {
      return (
        Number(item.quantidade_danificada || 0) +
        Number(item.quantidade_perdida || 0)
      );
    },
    saldoRetornoEditavel(item, condicional) {
      const saldoPendente = this.quantidadePendente(item);

      if (condicional?.id_nfe) {
        return saldoPendente;
      }

      return saldoPendente + this.saldoPerdaDanoEditavel(item);
    },
    podeProcessarRetorno(row) {
      return !row.id_nfe && [2, 3, 4, 8].includes(Number(row.status));
    },
    podeEditarCondicional(row) {
      return [1, 2].includes(Number(row.status));
    },
    editar(row) {
      this.$router.push({
        name: "condicionalMercadoriasEditar",
        params: { id: row.id_condicional_mercadoria },
      });
    },
    podeImprimirCondicional(row) {
      return Number(row.status) !== 7;
    },
    getErrorMessage(error, fallback) {
      return error?.response?.data?.msg || error?.message || fallback;
    },
    filtrosAtuais() {
      return this.filtersStore["condicional-mercadorias"]?.filters || {};
    },
    async carregarRelatorio() {
      try {
        const relatorio = await CondicionalMercadoriaData.relatorio(this, {
          columnFilters: this.filtrosAtuais(),
        });

        this.relatorio = {
          condicionais_em_aberto: 0,
          condicionais_vencidas: 0,
          quantidade_pecas_em_aberto: 0,
          valor_total_em_aberto: 0,
          produtos_em_condicional: [],
          ...relatorio,
        };
      } catch (error) {
        this.$toast.error(
          this.getErrorMessage(error, "Erro ao carregar relatório.")
        );
      }
    },
    aplicarFiltroStatus(status) {
      this.filtersStore["condicional-mercadorias"].filters = {
        ...this.filtrosAtuais(),
        status,
        vencidas: null,
      };
      this.filtersStore["condicional-mercadorias"].page = 1;
    },
    aplicarFiltroVencidas() {
      this.filtersStore["condicional-mercadorias"].filters = {
        ...this.filtrosAtuais(),
        vencidas: true,
      };
      this.filtersStore["condicional-mercadorias"].page = 1;
    },
    async carregarCondicional(idCondicional) {
      const [condicional, historico] = await Promise.all([
        CondicionalMercadoriaData.find(this, idCondicional),
        CondicionalMercadoriaData.historico(this, idCondicional),
      ]);

      this.condicionalSelecionada = condicional;
      this.historicoCondicional = Array.isArray(historico) ? historico : [];

      return condicional;
    },
    async visualizar(row) {
      try {
        await this.carregarCondicional(row.id_condicional_mercadoria);
        this.$bvModal.show("condicionalDetalhes");
      } catch (error) {
        this.$toast.error(
          this.getErrorMessage(error, "Erro ao carregar condicional.")
        );
      }
    },
    async abrirRetorno(row) {
      try {
        const condicional = await this.carregarCondicional(
          row.id_condicional_mercadoria
        );
        const itensPendentes = (condicional.itens || [])
          .filter((item) => this.saldoRetornoEditavel(item, condicional) > 0)
          .map((item) => this.montarItemRetorno(item, condicional));

        if (!itensPendentes.length) {
          this.$toast.info("Esta condicional não possui saldo editável.");
          return;
        }

        this.retornoCondicional = condicional;
        this.retornoItens = itensPendentes;
        this.retornoLeituraModo = "quantidade_devolvida";
        this.retornoCodigoLeitura = "";
        this.$bvModal.show("condicionalRetorno");
        this.focarLeitorRetorno();
      } catch (error) {
        this.$toast.error(
          this.getErrorMessage(error, "Erro ao carregar retorno.")
        );
      }
    },
    abrirModalImpressao(row) {
      this.condicionalImpressao = row;
      this.$bvModal.show("condicionalImpressao");
    },
    async imprimirCondicional(formato) {
      if (!this.condicionalImpressao) {
        return;
      }

      this.imprimindoCondicional = true;

      try {
        const resposta = await CondicionalMercadoriaData.imprimir(
          this,
          this.condicionalImpressao.id_condicional_mercadoria,
          formato
        );
        const url = resposta?.url_condicional || resposta?.url;

        if (!url) {
          throw new Error("Não foi possível localizar a URL da impressão.");
        }

        window.open(url, "_blank");
        this.$bvModal.hide("condicionalImpressao");
      } catch (error) {
        this.$toast.error(
          this.getErrorMessage(error, "Erro ao gerar impressão.")
        );
      } finally {
        this.imprimindoCondicional = false;
      }
    },
    montarItemRetorno(item, condicional) {
      const quantidadeDanificadaOriginal = Number(
        item.quantidade_danificada || 0
      );
      const quantidadePerdidaOriginal = Number(item.quantidade_perdida || 0);
      const ajustePerdaDano =
        !condicional?.id_nfe &&
        quantidadeDanificadaOriginal + quantidadePerdidaOriginal > 0;

      return {
        id_condicional_mercadoria_item: item.id_condicional_mercadoria_item,
        produto: this.descricaoProduto(item),
        codigo: item.codigo_produto_snapshot || item.produto?.codigo,
        codigos_busca: this.codigosRetornoItem(item),
        quantidade_pendente_original: this.saldoRetornoEditavel(
          item,
          condicional
        ),
        quantidade_danificada_original: quantidadeDanificadaOriginal,
        quantidade_perdida_original: quantidadePerdidaOriginal,
        ajuste_perda_dano: ajustePerdaDano,
        valor_unitario: this.valorUnitarioItem(item),
        quantidade_vendida: 0,
        quantidade_devolvida: 0,
        quantidade_danificada: ajustePerdaDano
          ? quantidadeDanificadaOriginal
          : 0,
        quantidade_perdida: ajustePerdaDano ? quantidadePerdidaOriginal : 0,
        manter_pendente: true,
      };
    },
    selecionarModoLeitura(campo) {
      this.retornoLeituraModo = campo;
      this.focarLeitorRetorno();
    },
    codigosRetornoItem(item) {
      const produto = item.produto || {};
      const candidatos = [
        item.codigo_produto_snapshot,
        produto.codigo,
        produto.cod_barras,
        produto.codigo_barras,
        produto.referencia,
        produto.id,
        item.id_produto,
        item.id_condicional_mercadoria_item,
      ];

      return [
        ...new Set(
          candidatos.map(this.normalizarCodigoRetorno).filter(Boolean)
        ),
      ];
    },
    normalizarCodigoRetorno(codigo) {
      if (codigo === undefined || codigo === null) {
        return "";
      }

      return String(codigo).trim().toLowerCase().replace(/\s+/g, "");
    },
    buscarItemRetornoPorCodigo(codigo) {
      const codigoNormalizado = this.normalizarCodigoRetorno(codigo);

      if (!codigoNormalizado) {
        return null;
      }

      const itensEncontrados = this.retornoItens.filter((item) =>
        (item.codigos_busca || []).includes(codigoNormalizado)
      );

      return (
        itensEncontrados.find(
          (item) => this.retornoItemPendente(item) > 0.0001
        ) || null
      );
    },
    lancarCodigoRetorno() {
      const codigo = this.normalizarCodigoRetorno(this.retornoCodigoLeitura);

      if (!codigo) {
        this.$toast.warning("Informe o código da mercadoria.");
        return;
      }

      const item = this.buscarItemRetornoPorCodigo(codigo);

      if (!item) {
        this.$toast.warning("Código não encontrado ou sem saldo editável.");
        this.retornoCodigoLeitura = "";
        this.focarLeitorRetorno();
        return;
      }

      if (!this.incrementarRetornoItem(item, this.retornoLeituraModo, 1)) {
        this.focarLeitorRetorno();
        return;
      }

      const acao =
        this.retornoLeituraModo === "quantidade_danificada"
          ? "avariado"
          : "devolvido";

      this.retornoCodigoLeitura = "";
      this.$toast.success(`${item.produto} ${acao}.`);
      this.focarLeitorRetorno();
    },
    incrementarRetornoItem(item, campoDestino, quantidade) {
      const saldo = this.retornoItemPendente(item);

      if (saldo <= 0.0001) {
        this.$toast.warning("Este item não possui saldo editável.");
        return false;
      }

      const quantidadeLancada = Math.min(Number(quantidade || 0), saldo);

      if (quantidadeLancada <= 0) {
        return false;
      }

      item[campoDestino] = Number(item[campoDestino] || 0) + quantidadeLancada;
      this.normalizarRetornoItem(item, campoDestino);

      return true;
    },
    marcarNaoLancadosComoVendidos() {
      let itensMarcados = 0;

      this.retornoItens.forEach((item) => {
        const saldo = this.retornoItemPendente(item);

        if (saldo <= 0.0001) {
          return;
        }

        item.quantidade_vendida = Number(item.quantidade_vendida || 0) + saldo;
        this.normalizarRetornoItem(item, "quantidade_vendida");
        itensMarcados += 1;
      });

      if (itensMarcados === 0) {
        this.$toast.info("Não há itens não selecionados.");
        return;
      }

      this.$toast.success("Itens não selecionados marcados como vendidos.");
    },
    focarLeitorRetorno() {
      this.$nextTick(() => {
        const input = this.$refs.retornoCodigoInput;
        const element = input?.$el || input;

        if (!element) {
          return;
        }

        element.focus?.();
        element.select?.();
      });
    },
    retornoItemTeveAlteracao(item) {
      if (!item.ajuste_perda_dano) {
        return this.quantidadeProcessadaRetorno(item) > 0;
      }

      return (
        Number(item.quantidade_vendida || 0) > 0 ||
        Number(item.quantidade_devolvida || 0) > 0 ||
        Math.abs(
          Number(item.quantidade_danificada || 0) -
            Number(item.quantidade_danificada_original || 0)
        ) > 0.0001 ||
        Math.abs(
          Number(item.quantidade_perdida || 0) -
            Number(item.quantidade_perdida_original || 0)
        ) > 0.0001
      );
    },
    quantidadeProcessadaRetorno(item) {
      return (
        Number(item.quantidade_vendida || 0) +
        Number(item.quantidade_devolvida || 0) +
        Number(item.quantidade_danificada || 0) +
        Number(item.quantidade_perdida || 0)
      );
    },
    retornoItemPendente(item) {
      return Math.max(
        0,
        Number(item.quantidade_pendente_original || 0) -
          this.quantidadeProcessadaRetorno(item)
      );
    },
    totalVendidoRetornoItem(item) {
      return (
        Number(item.quantidade_vendida || 0) * Number(item.valor_unitario || 0)
      );
    },
    retornoItemErro(item) {
      const processado = this.quantidadeProcessadaRetorno(item);
      const pendenteOriginal = Number(item.quantidade_pendente_original || 0);

      if (processado > pendenteOriginal + 0.0001) {
        return `A soma do item ${item.produto} ultrapassa o saldo editável.`;
      }

      if (!item.manter_pendente && this.retornoItemPendente(item) > 0.0001) {
        return `Marque manter pendente ou processe todo o saldo editável do item ${item.produto}.`;
      }

      return null;
    },
    normalizarRetornoItem(item, campoAlterado) {
      const campos = [
        "quantidade_vendida",
        "quantidade_devolvida",
        "quantidade_danificada",
        "quantidade_perdida",
      ];

      campos.forEach((campo) => {
        const valor = Number(item[campo] || 0);
        item[campo] = Number.isNaN(valor) ? 0 : Math.max(0, valor);
      });

      const excesso =
        this.quantidadeProcessadaRetorno(item) -
        Number(item.quantidade_pendente_original || 0);

      if (excesso > 0.0001) {
        if (
          item.ajuste_perda_dano &&
          ["quantidade_vendida", "quantidade_devolvida"].includes(campoAlterado)
        ) {
          let excessoRestante = excesso;

          ["quantidade_perdida", "quantidade_danificada"].forEach((campo) => {
            if (excessoRestante <= 0) {
              return;
            }

            const valorCampo = Number(item[campo] || 0);
            const quantidadeConsumida = Math.min(valorCampo, excessoRestante);
            item[campo] = valorCampo - quantidadeConsumida;
            excessoRestante -= quantidadeConsumida;
          });

          if (excessoRestante > 0.0001) {
            item[campoAlterado] = Math.max(
              0,
              Number(item[campoAlterado]) - excessoRestante
            );
          }
        } else {
          item[campoAlterado] = Math.max(
            0,
            Number(item[campoAlterado]) - excesso
          );
        }
      }

      if (this.retornoItemPendente(item) <= 0.0001) {
        item.manter_pendente = false;
      }
    },
    preencherRetorno(campoDestino) {
      this.retornoItens.forEach((item) => {
        item.quantidade_vendida = 0;
        item.quantidade_devolvida = 0;
        item.quantidade_danificada = 0;
        item.quantidade_perdida = 0;
        item[campoDestino] = Number(item.quantidade_pendente_original || 0);
        item.manter_pendente = false;
      });
    },
    processarRetorno() {
      if (!this.retornoPodeProcessar) {
        this.$toast.error(this.retornoErros[0] || "Revise as quantidades.");
        return;
      }

      let janelaPdv = null;

      swal({
        title: "Processar retorno?",
        text: "As quantidades devolvidas liberam estoque; perdas e avarias permanecem registradas.",
        icon: "warning",
        buttons: {
          cancel: { text: "Voltar", value: false, visible: true },
          confirm: { text: "Processar", value: true, visible: true },
        },
      }).then(async (confirmou) => {
        if (!confirmou) return;

        try {
          let cobrarPerdasDanos = false;

          if (this.retornoPossuiPerdaDano()) {
            cobrarPerdasDanos = await this.confirmarCobrancaPerdasDanos();
          }

          const deveAbrirPdv = this.retornoPossuiVenda() || cobrarPerdasDanos;

          if (deveAbrirPdv) {
            janelaPdv = window.open("about:blank", "_blank");
          }

          const payload = {
            id_condicional_mercadoria:
              this.retornoCondicional.id_condicional_mercadoria,
            itens: this.retornoMovimentos.map((item) => ({
              id_condicional_mercadoria_item:
                item.id_condicional_mercadoria_item,
              quantidade_vendida: Number(item.quantidade_vendida || 0),
              quantidade_devolvida: Number(item.quantidade_devolvida || 0),
              quantidade_danificada: Number(item.quantidade_danificada || 0),
              quantidade_perdida: Number(item.quantidade_perdida || 0),
              ajuste_perda_dano: Boolean(item.ajuste_perda_dano),
            })),
          };

          const condicional = await CondicionalMercadoriaData.processarRetorno(
            this,
            payload
          );

          if (deveAbrirPdv) {
            const vendaPdv = await CondicionalMercadoriaData.prepararVenda(
              this,
              condicional.id_condicional_mercadoria,
              { cobrar_perdas_danos: cobrarPerdasDanos }
            );
            this.abrirPdvCondicional(vendaPdv, janelaPdv);
          }

          this.$toast.success(
            deveAbrirPdv
              ? "Retorno processado e venda enviada ao PDV."
              : "Retorno processado com sucesso."
          );
          this.$bvModal.hide("condicionalRetorno");
          this.retornoCondicional = null;
          this.retornoItens = [];
          this.condicionalSelecionada = condicional;
          this.historicoCondicional = await CondicionalMercadoriaData.historico(
            this,
            condicional.id_condicional_mercadoria
          );
          this.$refs.condicionalList.refresh();
          this.carregarRelatorio();
        } catch (error) {
          if (janelaPdv && !janelaPdv.closed) {
            janelaPdv.close();
          }

          this.$toast.error(
            this.getErrorMessage(error, "Erro ao processar retorno.")
          );
        }
      });
    },
    retornoPossuiVenda() {
      return this.retornoItens.some(
        (item) => Number(item.quantidade_vendida || 0) > 0
      );
    },
    retornoPossuiPerdaDano() {
      return this.retornoItens.some(
        (item) =>
          Number(item.quantidade_danificada || 0) > 0 ||
          Number(item.quantidade_perdida || 0) > 0
      );
    },
    confirmarCobrancaPerdasDanos() {
      return swal({
        title: "Cobrar avarias ou perdas?",
        text: "Mercadorias avariadas ou perdidas devem ser enviadas para cobrança no PDV?",
        icon: "info",
        buttons: {
          cancel: { text: "Não cobrar", value: false, visible: true },
          confirm: { text: "Cobrar no PDV", value: true, visible: true },
        },
      });
    },
    abrirPdvCondicional(vendaPdv, janelaPdv = null) {
      const token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const storageKey = `nuts.condicionalMercadoria.pdvImport.${token}`;
      const payload = {
        ...vendaPdv,
        buyer: vendaPdv.cliente || {},
        vendedor: vendaPdv.vendedor || null,
        origem_condicional: {
          id_condicional_mercadoria: vendaPdv.id_condicional_mercadoria,
          numero_condicional: vendaPdv.numero_condicional,
        },
      };

      localStorage.setItem(storageKey, JSON.stringify(payload));

      const route = this.$router.resolve({
        name: "vendasNovo",
        query: { condicionalImport: token },
      });
      const url = new URL(route.href, window.location.href).href;

      if (janelaPdv && !janelaPdv.closed) {
        janelaPdv.location.href = url;
        return;
      }

      window.open(url, "_blank");
    },
    movimentoTipoLabel(tipo) {
      const labels = {
        1: "Criada",
        2: "Editada",
        3: "Saída confirmada",
        4: "Item vendido",
        5: "Item devolvido",
        6: "Item avariado",
        7: "Item perdido",
        8: "Prazo alterado",
        9: "Venda gerada",
        10: "Cancelada",
        11: "Fechada",
      };

      return labels[Number(tipo)] || "-";
    },
    confirmarSaida(row) {
      swal({
        title: "Confirmar saída?",
        text: "O estoque ficará reservado para esta condicional.",
        icon: "info",
        buttons: {
          cancel: { text: "Cancelar", value: false, visible: true },
          confirm: { text: "Confirmar", value: true, visible: true },
        },
      }).then(async (confirmou) => {
        if (!confirmou) return;

        try {
          await CondicionalMercadoriaData.confirmarSaida(
            this,
            row.id_condicional_mercadoria
          );
          this.$toast.success("Saída confirmada e estoque reservado.");
          this.$refs.condicionalList.refresh();
          this.carregarRelatorio();
        } catch (error) {
          this.$toast.error(
            this.getErrorMessage(error, "Erro ao confirmar saída.")
          );
        }
      });
    },
    cancelar(row) {
      swal({
        title: "Cancelar condicional?",
        text: "Informe o motivo do cancelamento.",
        content: {
          element: "input",
          attributes: {
            placeholder: "Motivo do cancelamento",
            type: "text",
          },
        },
        icon: "warning",
        buttons: ["Voltar", "Cancelar"],
        dangerMode: true,
      }).then(async (motivo) => {
        if (!motivo) return;

        try {
          await CondicionalMercadoriaData.cancelar(
            this,
            row.id_condicional_mercadoria,
            motivo
          );
          this.$toast.success("Condicional cancelada com sucesso.");
          this.$refs.condicionalList.refresh();
          this.carregarRelatorio();
        } catch (error) {
          this.$toast.error(
            this.getErrorMessage(error, "Erro ao cancelar condicional.")
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.action-buttons {
  align-items: center;
  display: inline-flex;
  flex-wrap: wrap;
}

.action-buttons .btn-icon {
  align-items: center;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.action-buttons ::v-deep .material-design-icon {
  align-items: center;
  display: inline-flex;
  height: 12px;
  justify-content: center;
  width: 12px;
}

.action-buttons ::v-deep .material-design-icon > .material-design-icon__svg {
  height: 12px;
  width: 12px;
}

.condicional-report-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.condicional-report-card {
  background: #ffffff;
  border: 1px solid #ebedf3;
  border-radius: 6px;
  color: #3f4254;
  min-height: 82px;
  padding: 16px;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.condicional-report-card:hover {
  border-color: #6993ff;
  box-shadow: 0 4px 12px rgba(24, 28, 50, 0.08);
}

.condicional-report-card span {
  color: #7e8299;
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.condicional-report-card strong {
  color: #181c32;
  display: block;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.condicional-print-action {
  background: #ffffff;
  border: 1px solid #dfe3ec;
  color: #ef6f61;
}

.condicional-print-action:hover,
.condicional-print-action:focus {
  background: #fff5f3;
  border-color: #ef6f61;
  color: #ef6f61;
}

.condicional-print-options {
  display: grid;
  gap: 12px;
}

.condicional-print-option {
  background: #fff;
  border: 1px solid #dfe3ec;
  border-radius: 6px;
  cursor: pointer;
  min-height: 84px;
  padding: 16px;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
}

.condicional-print-option:hover:not(:disabled) {
  border-color: #ef6f61;
  box-shadow: 0 8px 18px rgba(24, 28, 50, 0.08);
}

.condicional-print-option:disabled {
  cursor: wait;
  opacity: 0.7;
}

.condicional-print-title {
  color: #181c32;
  display: block;
  font-weight: 700;
  margin-bottom: 4px;
}

.condicional-print-description {
  color: #7e8299;
  display: block;
  font-size: 13px;
  line-height: 1.35;
}

.retorno-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.retorno-toolbar-main {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.retorno-toolbar-actions {
  align-items: center;
  display: flex;
}

.retorno-leitor-card {
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 10px 12px;
  width: 100%;
}

.retorno-leitor-label {
  color: #3f4254;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.retorno-leitor {
  align-items: center;
  display: flex;
}

.retorno-codigo-input {
  min-width: 220px;
}

.retorno-table th,
.retorno-table td {
  vertical-align: middle;
}

.retorno-table input {
  min-width: 92px;
}

@media (max-width: 1199px) {
  .condicional-report-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .retorno-toolbar-main,
  .retorno-leitor-card {
    align-items: flex-start;
    flex-direction: column;
  }

  .retorno-toolbar-actions {
    flex-wrap: wrap;
    gap: 8px;
  }
}

@media (max-width: 575px) {
  .condicional-report-grid {
    grid-template-columns: 1fr;
  }

  .retorno-codigo-input {
    max-width: none;
    width: 100%;
  }

  .retorno-leitor {
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
}
</style>
